import { OpenAPI as API } from '../services';
import { OpenAPI as ConversationsAPI } from '../services/conversations';
import { OpenAPI as ManagementAPI } from '../services/agents-management';

const removeTrailingSlashes = (url?: string): string => {
  if (!url?.length) return '';

  return url.replace(/\/+$/, '');
};

export * from './tasks';
export * from './analytics';
export * from './context';
export * from './contacts';
export * from './campaigns';
export * from './organization';
export * from './conversations';
export * from './campaignWebhooks';
export * from './contactStateMachine';
export * from './contactStateSettings';
export * from './dialerScheduleSettings';
export * from './prompts';
export * from './llm';
export * from './importer';
export * from './management';
export * from './messages';
export * from './misc';
export * from './bulkActions';
export * from './eventRules';
export * from './callerAgents';
export * from './agentComparison';

const BASE_URL = process.env.REACT_APP_API_URL;
const MANAGEMENT_URL = process.env.REACT_APP_MANAGEMENT_API_URL;

if (process.env.NODE_ENV === 'development') {
  API.BASE = '/api';
  ManagementAPI.BASE = '/api/management';
  ConversationsAPI.BASE = '/api/conversations_proxy';
} else {
  API.BASE = removeTrailingSlashes(BASE_URL);
  ConversationsAPI.BASE = removeTrailingSlashes(MANAGEMENT_URL);
  ManagementAPI.BASE = removeTrailingSlashes(MANAGEMENT_URL) + '/management';
}

export { API, ConversationsAPI, ManagementAPI };
